module.exports = __webpack_public_path__ + "img/xianyi.6da02864.png";